import Modal from "react-modal";
import { Suspense, lazy } from "react";

import LoginPage from "./components/login/LoginPage";
import RequireAuth from "./components/login/RequireAuth";
import { Routes, Route, useNavigate } from "react-router-dom";
import AdminHome from "./components/pages/AdminHome";
import OperatorHome from "./components/pages/OperatorHome";
import SupervisorHome from "./components/pages/SupervisorHome";
import Unauthorized from "./components/pages/Unauthorized";
import Missing from "./components/pages/Missing";
import ForgotPassword from "./components/pages/ForgotPassword";
import UploadReconcilation from "./components/reconcilation/UploadReconcilation";
import ReconciledReport from "./components/reconcilation/ReconciledReport";
import HotkeysHandler from "./hooks/HotkeysHandler";
import ReconcilationVerification from "./components/reconcilation/ReconcilationVerification";
import AddClaim from "./components/supervisor_home/AddClaim";
import ManualEntryView from "./components/manual_table_view/ManualEntryView";
import { ReactSession } from "react-client-session";
import Loader from "./components/Loader";
import Claim from "./components/claim/Claim";
import LoadingScreen from "./components/LoadingScreen";
import InvoicePage from "./components/invoice/invoice_page/InvoicePage";

const Scan = lazy(() => import("./components/pages/Scan"));
const Manual = lazy(() => import("./components/pages/Manual"));

function App() {
  ReactSession.setStoreType("sessionStorage");
  Modal.setAppElement("#root");

  const navigate = useNavigate();

  const accessToken = ReactSession.get("accessToken");
  const role = ReactSession.get("role");

  return (
    <div>
      <HotkeysHandler
        keys="shift+alt+m"
        handler={() => {
          if (accessToken && role === "3") {
            navigate("/manual-entry");
          }
        }}
      />

      <HotkeysHandler
        keys="shift+alt+s"
        handler={() => {
          if (accessToken && role === "3") {
            navigate("/scan");
          }
        }}
      />

      <HotkeysHandler
        keys="shift+alt+h"
        handler={() => {
          if (accessToken && role === "3") {
            navigate("/operator");
          }
        }}
      />
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          {/* PUBLIC ROUTES */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<Missing />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* PRIVATE ROUTES */}
          {/* ADMIN  */}
          <Route element={<RequireAuth allowedRole={["1"]} />}>
            <Route path="/admin" element={<AdminHome />} />
          </Route>
          {/* SUPERVISOR  */}

        <Route element={<RequireAuth allowedRole={["2", "3"]} />}>
          <Route path="/upload" element={<UploadReconcilation />} />
          <Route path="/reconciled-report" element={<ReconciledReport />} />
          <Route path="/reconcilation" element={<ReconcilationVerification />} />
          <Route path="/stockist-report" element={<Claim />} />
          <Route path="/add-claim" element={<AddClaim />} />
          <Route path="/manual-entry-view" element={<ManualEntryView />} />
          <Route path="/invoice-page" element={<InvoicePage />} />
        </Route>

          <Route element={<RequireAuth allowedRole={["2"]} />}>
            <Route path="/supervisor" element={<SupervisorHome />} />
          </Route>
          {/* OPERATOR  */}

          <Route element={<RequireAuth allowedRole={["3"]} />}>
            <Route path="/operator" element={<OperatorHome />} />
            <Route path="/manual-entry" element={<Manual />} />
            <Route path="/scan" element={<Scan />} />
          </Route>
        </Routes>
      </Suspense>
      <Loader />
    </div>
  );
}

export default App;
